require('./lbaPointsOfInterestItemForm.scss');

const lbaPointsOfInterestItemForm = angular.module('app.lbaPointsOfInterestItemForm', []);

lbaPointsOfInterestItemForm.component('lbaPointsOfInterestItemForm', {
  bindings: {
    pointOfInterest: '=',
    toggleDetail: '=',
    saveItem: '=',
    deleteItem: '='
  },
  controller: ['$scope', 'lbaLeafletMapService', lbaPointsOfInterestItemFormCtrl],
  template: `
    <div class="lbaPointsOfInterest_ItemForm">
      <div class="lbaPointsOfInterest_ItemForm_header">
        <h3 ng-if="!$ctrl.update">New</h3>
        <h3 ng-if="$ctrl.update">Edit</h3>
        <button class="lbaPointsOfInterest_ItemForm_back btn" ng-click="$ctrl.toggleDetail()"><span class="fa fa-chevron-left"></span></button>
      </div>

      <form>
        <div class="form-group">
          <label>Title</label>
          <input type="text" ng-model="$ctrl.tempPointOfInterest.Title" placeholder="Name" class="form-control" >
        </div>

        <div class="form-group">
          <label>Description</label>
          <textarea ng-model="$ctrl.tempPointOfInterest.Description" placeholder="Description" class="form-control" ></textarea>
        </div>

        <div class="form-group">
          <label>Address</label>
          <textarea ng-model="$ctrl.tempPointOfInterest.Address" placeholder="Address" class="form-control" ng-change="$ctrl.clearErrors()" ></textarea>
        </div>
        <div class="form-group">
          <div>
            <button class="btn lbaPointsOfInterest_addPosition" ng-click="$ctrl.addPosition()" ng-disabled="$ctrl.searchingPosition"><span class="fa fa-thumb-tack"></span></button>
            <label>Position</label>
            <p class="error text-warning" ng-if="$ctrl.errors.position">{{$ctrl.errors.position}}</p>
          </div>
          <label>Longitude</label>
          <input type="text" ng-model="$ctrl.tempPointOfInterest.Longitude" placeholder="Longitude" class="form-control" ng-class="{'not-valid': !$ctrl.isLongitudeValid && !$ctrl.searchingPosition}" ng-required="true">
        </div>
        <div class="form-group">
        <label>Latitude</label>
          <input type="text" ng-model="$ctrl.tempPointOfInterest.Latitude" placeholder="Latitude" class="form-control" ng-class="{'not-valid': !$ctrl.isLatitudeValid && !$ctrl.searchingPosition}" ng-required="true">
        </div>
        <div class="form-group">
        <label>Sort Order (Descending Order)</label>
          <input type="number" ng-model="$ctrl.tempPointOfInterest.SortOrder" placeholder="Enter sort order" class="form-control" ng-required="false">
        </div>

        <div class="form-group">
          <p>
            <button class="btn-primary btn lbaPointsOfInterest_saveItem" ng-click="$ctrl.savePointOfInterest()" ng-if="!$ctrl.update" ng-disabled="$ctrl.saving">Save</button>
            <button class="btn-primary btn lbaPointsOfInterest_saveItem" ng-click="$ctrl.updatePointOfInterest()" ng-if="$ctrl.update" ng-disabled="$ctrl.saving">Update</button>
          </p>
        </div>
        <div class="form-group">
          <p>
            <button class="btn-danger btn lbaPointsOfInterest_deleteItem" ng-click="$ctrl.deletePointOfInterest()" ng-if="$ctrl.update" ng-disabled="$ctrl.saving">Delete</button>
          </p>
          <p class="error text-warning">{{$ctrl.errors.delete}}</p>
        </div>
      </form>
    </div>
  `
});

function lbaPointsOfInterestItemFormCtrl($scope, lbaLeafletMapService) {
  const longitudeErrorMessage = "Longitude must be between -180 and 180";
  const latitudeErrorMessage = 'Latitude must be between -90 and 90';

  let $ctrl = this;

  $ctrl.tempPointOfInterest = {};
  $ctrl.saving = false;
  $ctrl.update = false;
  $ctrl.errors = {};
  $ctrl.isLongitudeValid = true;
  $ctrl.isLatitudeValid = true;
  $ctrl.searchingPosition = false;

  if($ctrl.pointOfInterest) {
    $ctrl.update = true;
    angular.copy($ctrl.pointOfInterest, $ctrl.tempPointOfInterest);
  }

  $ctrl.savePointOfInterest   = savePointOfInterest;
  $ctrl.deletePointOfInterest = deletePointOfInterest;
  $ctrl.updatePointOfInterest = updatePointOfInterest;
  $ctrl.addPosition           = addPosition;
  $ctrl.clearErrors           = clearErrors;

  function savePointOfInterest(){
    if($ctrl.isLongitudeValid && $ctrl.isLatitudeValid){
      $ctrl.saving = true;
      $ctrl.saveItem($ctrl.tempPointOfInterest)
        .then(result=>{
          $ctrl.saving = false;
          $ctrl.toggleDetail();
        })
    }else{
      $ctrl.errors.position = 'Please enter a valid position';
    }
  }

  function updatePointOfInterest(){
    if($ctrl.isLongitudeValid && $ctrl.isLatitudeValid){
      $ctrl.saving = true;
      $ctrl.saveItem($ctrl.tempPointOfInterest)
        .then(result=>{
          $ctrl.toggleDetail();
        })
        .catch(()=>{
          $ctrl.errors.delete = 'Error updating item';
        })
        .finally(() => {
          $ctrl.saving = false;
        });
    }else{
      $ctrl.errors.position = 'Please enter a valid position';
    }
  }

  function clearErrors(){
    $ctrl.errors = {};
  }

  function deletePointOfInterest(){
    $ctrl.saving = true;

    $ctrl.deleteItem($ctrl.tempPointOfInterest.Id)
      .then(result=>{
        $ctrl.toggleDetail();
      })
      .catch(()=>{
        $ctrl.errors.delete = 'Error deleting item';
      })
      .finally(() => {
        $ctrl.saving = false;
      });;
  }

  $scope.$watchCollection('$ctrl.tempPointOfInterest', () => {
    // Don't show validation errors while searching for position
    if ($ctrl.searchingPosition) {
      return;
    }
    
    $ctrl.errors.position = "";
    $ctrl.isLongitudeValid = $ctrl.tempPointOfInterest.Longitude <= 180 && $ctrl.tempPointOfInterest.Longitude >= -180;
    $ctrl.isLatitudeValid =  $ctrl.tempPointOfInterest.Latitude <= 90 && $ctrl.tempPointOfInterest.Latitude >= -90;

    if (!$ctrl.isLongitudeValid) {
      $ctrl.errors.position = getPositionMessage($ctrl.errors.position, longitudeErrorMessage);
    }

    if(!$ctrl.isLatitudeValid){
      $ctrl.errors.position = getPositionMessage($ctrl.errors.position, latitudeErrorMessage);
    }
  });

  function addPosition(){
    if($ctrl.tempPointOfInterest.Address){
      $ctrl.searchingPosition = true;
      $ctrl.errors.position = "";
      
      lbaLeafletMapService.getPosByAddress($ctrl.tempPointOfInterest.Address)
        .then(data=>{
          let resources = data.resourceSets[0].resources;
          if(resources.length > 0){
            $ctrl.tempPointOfInterest.Longitude = resources[0].geocodePoints[0].coordinates[1];
            $ctrl.tempPointOfInterest.Latitude = resources[0].geocodePoints[0].coordinates[0];
          } else {
            $ctrl.errors.position = 'problem recognising address';
          }
        })
        .catch(data=>{
          $ctrl.errors.position = 'problem recognising address';
        })
        .finally(() => {
          $ctrl.searchingPosition = false;
        });
    }
  }

  function getPositionMessage(existingMessage, message){
    return !!existingMessage ? existingMessage+=`, ${message}`: message;
  }

}

export default lbaPointsOfInterestItemForm;


// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterestItemForm/lbaPointsOfInterestItemForm.js